export default "__VITE_ASSET__Cu5_w0EP__"